<template>
	<v-dialog v-model="dialog" scrollable max-width="600" >
		<template v-slot:activator="{ on }">
			<v-btn  color="primary" icon small v-on="on" title="Configurações">
				<v-icon small> mdi-cog </v-icon>
			</v-btn>
		</template>
		<v-card outlined class="">
			<v-card-title>
				<v-row dense>
					Configurações
					<v-spacer></v-spacer>
					<v-btn  color="primary" small icon @click="dialog=false" >
						<v-icon> mdi-close </v-icon>
					</v-btn>
				</v-row>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col sm="12" cols="12">
						<tiptap-vuetify :card-props="{ outlined:true }" v-model="instrucao.instrucoes_reserva" :extensions="extensions" />
					</v-col>
					<v-col sm="12" cols="12">
						<v-text-field v-model="instrucao.link_protocolo_pratica" label="Link Procedimento prático"></v-text-field>
					</v-col>
					<v-col sm="12" cols="12">
						<v-text-field v-model="instrucao.link_roteiro_solicitacao" label="Link Lista de Materiais"></v-text-field>
					</v-col>
					<v-col sm="6" cols="12">
						<v-text-field type="number" v-model="instrucao.carencia_minima" label="Carência de abertura (dias úteis)"></v-text-field>
					</v-col>
					<v-col sm="6" cols="12">
						<v-text-field type="number" v-model="instrucao.duracao_maxima" label='Duração máxima(minutos)'></v-text-field>
					</v-col>
					<v-col sm="6" cols="12">
						<v-text-field type="number" v-model="instrucao.duracao_minima" label="Duração mínima(minutos)"></v-text-field>
					</v-col>
					<v-col sm="6" cols="12">
						<v-text-field type="number" v-model="instrucao.limite_exibicao" label="Limite de exibição (dias)"></v-text-field>
					</v-col>
					<v-col sm="6" cols="12">
						<v-checkbox type="number" v-model="instrucao.permite_sabado" label='Permitir reservas no Sábado'></v-checkbox>
					</v-col>
					<v-col sm="6" cols="12">
						<v-checkbox type="number" v-model="instrucao.permite_domingo" label='Permitir reservas no Domingo'></v-checkbox>
					</v-col>
					<v-col sm="6" cols="12">
						<v-checkbox type="number" v-model="instrucao.permite_feriado" label='Permitir reservas em Feriado Nacional'></v-checkbox>
					</v-col>

				</v-row>
				
			
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn elevation="0" color="primary" :loading="$store.globalStore.state.loading" @click="salvar(instrucao)">Salvar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'

export default {
	name: 'InstrucaoForm',
	components:{
		TiptapVuetify
	},
	props:{
		instrucao:{
			required: true
		}
	},
	data () {
		return {
			dialog: false,
			extensions: [
				History,
				Blockquote,
				Link,
				Underline,
				Strike,
				Italic,
				ListItem,
				BulletList,
				OrderedList,
				[Heading, {
					options: {
					levels: [1, 2, 3]
					}
				}],
				Bold,
				Code,
				HorizontalRule,
				Paragraph,
				HardBreak
				],
		}   
	},
	computed:{
		
	},
	methods:{
		salvar(object){
			this.$store.globalStore.dispatch('update_settings', {pk: object.id, data: object})
		}
	},
	mounted(){

	}
}
</script>